import React, { FC, useCallback, useEffect, useState } from 'react'
import './FilterCourseCharacteristics.scss'
import { Accordion, Card } from 'react-bootstrap'
import { MdExpandMore } from "react-icons/md";
import CheckBoxComponent from 'app_components/commons/checkBox/containers/checkBoxComponent';
import FilterSearchText from '../FilterSearchText/FilterSearchText';
import CourseService from 'app_services/campus/academic/courseService';
import { IFilterItem } from 'app_types/campus/academic/courseTypes';
import { ArrayParam, StringParam, useQueryParams } from 'use-query-params';
import ButtonComponent from 'app_components/commons/Button/ButtonComponent';

export interface IFilterOnChangeParams {
  search?: string
  startDate?: string
  endDate?: string
  filterCategories?: string[]
  mode?: string[]
}

export enum FILTER_COURSE_CHARACTERISTICS_ITEMS {
  SEARCH = 'search',
  COURSE_TOPIC = 'course-topic',
  COURSE_SECTOR = 'course-sector',
  COURSE_FORMATION_TYPE = 'course-formation-type',
  COURSE_PROFILE = 'course-profile',
  MODALITY = 'modality',
  DATES = 'dates'
}

interface IFilterCourseCharacteristicsProps {
  onChange?: (params: IFilterOnChangeParams) => void
  onFilter?: () => void
  defaultOpen?: boolean
  updateSearchParams?: boolean
  itemsToShow?: FILTER_COURSE_CHARACTERISTICS_ITEMS[]
}

const SEARCH_TEXT_TIMEOUT = 200

const FilterCourseCharacteristics: FC<IFilterCourseCharacteristicsProps> = ({
  onChange,
  onFilter,
  defaultOpen,
  updateSearchParams = true,
  itemsToShow
}) => {

  const [search, setSearch] = useState<string>();
  const [dateFrom, setDateFrom] = useState<string>();
  const [dateTo, setDateTo] = useState<string>();
  const [activeModalities, setActiveModalities] = useState<IFilterItem[]>([])
  const [filters, setFilters] = useState<IFilterItem[]>([])
  const [selectedItems, setSelectedItems] = useState<string[]>([])
  const [selectedModalities, setSelectedModalities] = useState<string[]>([])
  const [canSetFilter , setCanSetFilter] = useState<boolean>(false)
  const [query, setQuery] = useQueryParams({
    search: StringParam,
    startDate: StringParam,
    endDate: StringParam,
    filterCategories: ArrayParam,
    mode: ArrayParam,
  })

  const saveFilterOnUrl = useCallback(() => {
    if (!canSetFilter) return
    const dataToSave: IFilterOnChangeParams = {
      search: search?.length ? search : undefined,
      startDate: dateFrom?.length ? dateFrom : undefined,
      endDate: dateTo?.length ? dateTo : undefined,
      filterCategories: selectedItems,
      mode: selectedModalities
    }
    onChange && onChange(dataToSave)
    if (updateSearchParams) {
      setQuery(dataToSave)
    }
  }, [canSetFilter, dateFrom, dateTo, onChange, search, selectedItems, selectedModalities, setQuery, updateSearchParams])

  useEffect(() => {
    saveFilterOnUrl()
  }, [selectedItems, selectedModalities, dateFrom, dateTo])

  useEffect(() => {
    const timeout = setTimeout(() => {
      saveFilterOnUrl()
    }, SEARCH_TEXT_TIMEOUT)
    return () => {
      clearTimeout(timeout)
    }
  }, [search])

  useEffect(() => {
    if (query.search) {
      setSearch(query.search)
    }
    if (query.startDate) {
      setDateFrom(query.startDate)
    }
    if (query.endDate) {
      setDateTo(query.endDate)
    }
    if (query.filterCategories) {
      setSelectedItems(query.filterCategories as string[])
    }
    if (query.mode) {
      setSelectedModalities(query.mode as string[])
    }
    setCanSetFilter(true)
  }, [])

  const getFilter = async () => {
    const courseService = new CourseService()
    const response = await courseService.getActivePublicFilter()

    if(response){
      setActiveModalities(response.activeModalities)
      setFilters(response.filters)
    }
  }
  useEffect(() => {
    getFilter()
  }, [])

  const handleClickItem = (id: string) => {
    const itemIndex = selectedItems.findIndex((item) => item===id)
    if (itemIndex >= 0){
      const newItems= [...selectedItems]
      newItems.splice(itemIndex, 1)
      setSelectedItems(newItems)
    } else {
      const newItems = [...selectedItems]
      newItems.push(id)
      setSelectedItems(newItems)
    }
  }

  const handleClickModality = (id: string) => {
    const itemIndex = selectedModalities.findIndex((item) => item===id)
    if (itemIndex >= 0){
      const newItems= [...selectedModalities]
      newItems.splice(itemIndex, 1)
      setSelectedModalities(newItems)
    } else {
      const newItems = [...selectedModalities]
      newItems.push(id)
      setSelectedModalities(newItems)
    }
  }

  const handleClickClear = () => {
    setSearch('')
    setDateFrom('')
    setDateTo('')
    setSelectedItems([])
    setSelectedModalities([])
  }

  return (
    <div className='filter-course-characteristics--container'>
      {(!itemsToShow || itemsToShow?.includes(FILTER_COURSE_CHARACTERISTICS_ITEMS.SEARCH)) && (
        <div>
          <div className='filter-course-characteristics--title'>Filtrar por</div>
          <FilterSearchText value={search} onChange={(event) => {setSearch(event.target.value)}}/>
        </div>
      )}
      <div className='filter-course-characteristics--container-accordion'>
        {filters?.filter((item) => !itemsToShow || itemsToShow?.includes(item.typeRelated as FILTER_COURSE_CHARACTERISTICS_ITEMS))?.map((filter) => (
          <Accordion key={filter.value} defaultActiveKey={defaultOpen ? "0" : undefined}>
            <Card style={{border: 'none'}}>
              <Accordion.Toggle as={Card.Header} eventKey="0" className='filter-course-characteristics--title-line' >
                <div className='filter-course-characteristics--title-accordion' >
                  {filter.name}
                  <MdExpandMore color='gray'/>
                </div>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="0">
                <Card.Body style={{padding: 0, display: 'flex', flexDirection: 'column'}}>
                  {filter.childs?.map((child) => (
                    <div onClick={()=>handleClickItem(child.value)} key={child.value} className='filter-course-characteristics--course-container'>
                      <CheckBoxComponent className='filter-course-characteristics--checkbox' checked={selectedItems.includes(child.value)} onClick={()=>handleClickItem(child.value)}/>
                      <p className='filter-course-characteristics--course-title'>{child.name}</p>
                    </div>
                  ))}
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        ))}

        {!!activeModalities.length && (!itemsToShow || itemsToShow?.includes(FILTER_COURSE_CHARACTERISTICS_ITEMS.MODALITY)) && (
          <Accordion defaultActiveKey={defaultOpen ? "0" : undefined}>
            <Card style={{border: 'none'}}>
              <Accordion.Toggle as={Card.Header} eventKey="0" className='filter-course-characteristics--title-line' >
                <div className='filter-course-characteristics--title-accordion' >
                  Modalidad
                  <MdExpandMore color='gray'/>
                </div>
              </Accordion.Toggle>
              <Accordion.Collapse eventKey="0">
                <Card.Body style={{padding: 0, display: 'flex', flexDirection: 'column'}}>
                  {activeModalities.map((modality) => (
                    <div onClick={()=>handleClickModality(modality.value)} key={modality.value} className='filter-course-characteristics--course-container'>
                      <CheckBoxComponent className='filter-course-characteristics--checkbox' checked={selectedModalities.includes(modality.value)} onClick={()=>handleClickModality(modality.value)}/>
                      <p className='filter-course-characteristics--course-title'>{modality.name}</p>
                    </div>
                  ))}
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        )}
        {(!itemsToShow || itemsToShow?.includes(FILTER_COURSE_CHARACTERISTICS_ITEMS.DATES)) && (
          <div style={{marginTop: 25}}>
            < div>
              <p className='filter-course-characteristics--input-from'>Desde</p>
              <input value={dateFrom} onChange={(event) => {setDateFrom(event.target.value)}} type='date' className='filter-course-characteristics--input-date'></input>
            </div>
            <div>
              <p className='filter-course-characteristics--input-from'>Hasta</p>
              <input value={dateTo} onChange={(event) => {setDateTo(event.target.value)}} type='date' className='filter-course-characteristics--input-date'></input>
            </div>
          </div>
        )}
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginTop: '24px' }}>
        <ButtonComponent
          fontSize="18px"
          width="100%"
          textTransform='none'
          onClick={handleClickClear}
        >
          Limpiar filtros
        </ButtonComponent>
        {onFilter && (
          <ButtonComponent onClick={onFilter} variant='secondary'>
            Aplicar
          </ButtonComponent>
        )}
      </div>
    </div>
  )
}

export default FilterCourseCharacteristics
